import { lazy } from 'react';
import PageView from './PageView';

const CustomerCardPage = lazy(() => import('src/pages/customerCard'));
const CustomerPage = lazy(() => import('src/pages/customer'));

export const customersRoutes = [
  {
    path: 'customer-card',
    element: <PageView permission="BO_CAN_VIEW_CUSTOMERS" />,
    children: [{ element: <CustomerCardPage />, index: true }],
  },
  {
    path: 'customer',
    element: <PageView permission="BO_CAN_VIEW_CUSTOMERS" />,
    children: [{ element: <CustomerPage />, index: true }],
  },
];
